export default __webpack_public_path__ + "static/media/water.20a960be.svg";